import React, { memo, useState } from 'react';
import { Handle, Position } from 'reactflow';
import cx from 'classnames';

import PlusIconComponent from './PlusIconComponent';

import * as styles from '../styles.module.css';
import InitialNodeContent from '../Contents/InitialNodeContent';

const InitialNode = ({
  id, data, sourcePosition, targetPosition
}) => {
  // id -> Es el id del node
  const [isDropzoneActive] = useState(false);

  const onClick = (e) => {
    e.stopPropagation();
    data.addNode(id, data, true);
  };

  const className = cx(styles.node, { [styles.nodeDropzone]: isDropzoneActive });

  const displayPlusIcon = () => true;

  return (
    <>
      <div className={className}>
        <Handle className={styles.handle} type="target" position={targetPosition || Position.Top} />
        <Handle className={styles.handle} type="source" position={sourcePosition || Position.Bottom} />
        <InitialNodeContent
          nodeId={id}
          nodeData={data}
        />
      </div>
      {displayPlusIcon() && (
        <PlusIconComponent onClick={onClick} />
      )}
    </>
  );
};

export default memo(InitialNode);
